<div class="team-header-wrapper">
  <ui-assignee-avatar class="team-header-avatar" [fromAssigneeId]="teamId" [uiShowTooltip]="true" uiSize="xl"></ui-assignee-avatar>
  <div class="team-header-name-date-wrapper">
    <ui-assignee-name class="team-header-name" [fromAssigneeId]="teamId"></ui-assignee-name>
    <p class="team-header-created-on">
      <span>{{ "created_on" | localize }}</span
      ><span>&nbsp;{{ teamCreatedOnDate | dayjsDate : "MMMM DD, YYYY" }}</span>
    </p>
  </div>
</div>
